import { observer } from "mobx-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatNumber } from "utils/formatHelper";
import moment from "moment";
import { PAGE_SIZE_DEFAULT } from "utils/constants";
import { Link, useNavigate } from "react-router-dom";

// components
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";
import {
  Autocomplete,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from "@mui/material";
import Pagination from "base/ui/components/Pagination/pagination";
import { TbLoaderQuarter } from "react-icons/tb";
import { FaSearch } from "react-icons/fa";

// Model
import {
  ListStatusProduct,
  ListDate,
  DropdownRouting,
} from "services/commonDate_services";
import { HistoryReceiveModel } from "services/historyReceive_sevieces";
import { SearchModel } from "./models";
// Store - presenter
import {
  commonDatePresenter,
  commonDateStore,
  historyReceivePresenter,
  historyReceiveStore,
} from "stores/root_store";
import { Button, Form, Input, Select as AntdSelect, DatePicker } from "antd";
import { AiOutlineDownload } from "react-icons/ai";
import { ActionType, ProColumns } from "@ant-design/pro-components";
import CustomProTable from "base/ui/components/CustomTable";
import { debounce } from "@mui/material";
import dayjs from "dayjs";
import { useResizableColumns } from "utils/reportHelper";
import SaveReportForm from "pages/report/reportComponents/reportForm";
import TemplateReportModal from "base/ui/components/Modal/TemplateReportModal";
import { isSafeInteger } from 'lodash';



export function createHistoryRecieve() {

  return observer(() => {
    // navigate
    //==========================Loading ===================//
    // Loading của cả trang nếu gửi api thì cho loading
    const [loading, setLoading] = useState(true);
    // loading khi search
    const [searchLoading, setSearchLoading] = useState(false);
    //========================================================//

    // ==============Data table ==========================//
    const [dataTable, setDataTable] = useState<HistoryReceiveModel[]>([]);
    // ===================================================//

    // ==================Common date ===========================//
    // danh sách date
    const [listCommonDate, setListCommonDate] = useState<ListDate[]>([]);
    // ===============================================================
    // autocomplete tp/btp
    const [dropdownProduct, setDropdownProduct] = useState<ListStatusProduct[]>(
      []
    );
    // autocomplete WO
    const [dropdownWO, setDropdownWO] = useState<ListStatusProduct[]>([]);
    // data dropdown routing
    const [listRouting, setListRouting] = useState<DropdownRouting[]>([]);

    // tình trạng tp/btp
    const [tpbtpStatus, setTpbtpStatus] = useState<ListStatusProduct[]>([{ key: '', value: "-- Tất cả --" }]);
    // data search
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderByDesc: "",
        orderBy: "",
      },
      receiveNumber: undefined,
      lotNumber: undefined,
      productCode: undefined,
      workOrderCode: undefined,
      statusReceive: undefined,
      stepCode: undefined,
      fromDate: undefined,
      toDate: undefined,
    });

    const [form] = Form.useForm()

    // =================================================================================//
    // Lấy danh sách tình trạng nhập kho

    // Lấy danh sách day
    const getListCommonDate = async () => {
      await commonDatePresenter.getListCommonDate(commonDateStore);
      if (commonDateStore.listDate.isSuccess) {
        setListCommonDate(commonDateStore.listDate.data);
      }
    };

    // lấy danh sách lịch sử nhập kho
    const getListDataTable = async (data = dataSearch) => {
      await historyReceivePresenter.getHistoryReceive(
        historyReceiveStore,
        data
      );
      if (historyReceiveStore.historyReceiveResponse.isSuccess) {
        setDataTable(historyReceiveStore.historyReceiveResponse.data);
      }
    };

    // Lấy dropdown products
    const getDropdownProduct = async (kw?: string) => {
      await commonDatePresenter.getListDropdownProduct(
        commonDateStore,
        kw || ''
      );
      setDropdownProduct(commonDateStore.listDropdownProduct);
    };
    const searchProduct = useCallback(debounce(getDropdownProduct, 500), []);

    // lấy dropdown Wo
    const getDropdownWO = async (keyword = '') => {
      await commonDatePresenter.getDropdownWo(commonDateStore, keyword);
      if (commonDateStore.listStatusProductResponse.isSuccess) {
        setDropdownWO(commonDateStore.listStatusProductResponse.data);
      }
    };
    const searchWO = useCallback(debounce(getDropdownWO, 300), []);

    // Lấy dropdown công đoạn
    const getDataDropdownRouting = async (dataSearch = "") => {
      await commonDatePresenter.getDropdownRouting(commonDateStore, dataSearch);
      if (commonDateStore.dropdownRouting.isSuccess) {
        setListRouting(commonDateStore.dropdownRouting.data);
      }
    };
    const searchRouting = useCallback(debounce(getDataDropdownRouting, 300), []);

    const getListStatus = async () => {
      await commonDatePresenter.getDropdownByKeyword(
        commonDateStore,
        "StatusReceive"
      );
      if (commonDateStore.dropdownByKey) {
        const data = commonDateStore.dropdownByKey
        setTpbtpStatus(prev => ([...prev, ...data]));
      }
    };

    const commonNgayNK = Form.useWatch('commonDate', form)



    const getDayByCommonDate = async (key: string) => {
      if (key == 'Custom') {
        form.setFieldsValue({ fromDate: undefined, toDate: undefined })
      } else {
        await commonDatePresenter.getDataByCommonDate(commonDateStore, key);
        if (commonDateStore.commonDate.fromDate && commonDateStore.commonDate.toDate) {
          form.setFieldsValue({ fromDate: dayjs(commonDateStore.commonDate.fromDate), toDate: dayjs(commonDateStore.commonDate.toDate) })
        }
      }
    }

    useEffect(() => {
      const getData = async () => {
        Promise.allSettled([getListCommonDate(),
        getDropdownProduct(),
        getDataDropdownRouting(),
        getListStatus(),
        getDropdownWO(),
        getDayByCommonDate('Today').then(() => {
          getListDataTable({ ...dataSearch, fromDate: commonDateStore.commonDate.fromDate, toDate: commonDateStore.commonDate.toDate })
        })]).then(() => { setLoading(false) })

      };
      getData();
    }, []);

    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //================================================================
    const [columns, setColumns] = useState<ProColumns<HistoryReceiveModel>[]>([
      // STT
      {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 70,
        fixed: "left",
        onCell: () => ({
          className: 'text-center',
        }),
      },
      // Số phiếu nhập kho
      {
        title: "Số phiếu nhập kho",
        dataIndex: "receiveCode",
        key: "receiveCode",
        width: 140,
        fixed: "left",
        render: (text, record) => {
          return <Link
            target="_blank"
            to={record.id}
            className=" text-default py-0.25 rounded-base px-2.5 hover:text-sky-400"
          >
            {text}
          </Link>
        }
      },
      // Số LOT
      {
        title: "Số LOT",
        dataIndex: "lotNumber",
        key: "lotNumber",
        width: 100,
        fixed: "left",
      },
      // Số lượng nhập kho
      {
        title: "Số lượng nhập kho",
        dataIndex: "soLuongNk",
        key: "soLuongNk",
        width: 150,
        onCell: () => ({
          className: 'text-right',
        }),
        render(text, record) {
          return text ? isSafeInteger(text) ? formatNumber(Number(text), 0) : formatNumber(Number(text), 2) : '-'
        },
      },
      // Loại LSX
      {
        title: "Loại LSX",
        dataIndex: "typeLSX",
        key: "typeLSX",
        width: 80,
      },
      // LSX
      {
        title: "LSX",
        dataIndex: "workOrderCode",
        key: "workOrderCode",
        width: 100,
      },
      // Work Order Completion
      {
        title: "Work Order Completion",
        dataIndex: "workOrderCompletion",
        key: "workOrderCompletion",
        width: 170,
      },
      // Mã TP/BTP
      {
        title: "Mã TP/BTP",
        dataIndex: "productCode",
        key: "productCode",
        width: 140,
      },
      // TP/BTP
      {
        title: "TP/BTP",
        dataIndex: "productName",
        key: "productName",
        width: 350,
      },
      // Công đoạn nhập kho
      {
        title: "Công đoạn nhập kho",
        dataIndex: "stepCode",
        key: "stepCode",
        width: 300,
      },
      // Tình trạng TP/BTP nhập kho
      {
        title: "Tình trạng TP/BTP nhập kho",
        dataIndex: "statusReceive",
        key: "statusReceive",
        width: 200,
      },
      // Số lượng phát lệnh
      {
        title: "Số lượng phát lệnh",
        dataIndex: "slPhatLenh",
        key: "slPhatLenh",
        width: 150,
        onCell: () => ({
          className: 'text-right',
        }),
        render(text, record) {
          return text !== '-' ? formatNumber(Number(text), 0) : text
        },
      },
      // ĐVT
      {
        title: "ĐVT",
        dataIndex: "dvt",
        key: "dvt",
        width: 100,
      },
      // Tổng số phiếu nhập kho
      {
        title: "Tổng số phiếu nhập kho",
        dataIndex: "qtyReceive",
        key: "qtyReceive",
        width: 170,
        onCell: () => ({
          className: 'text-right',
        }),
        render(text, record) {
          return text !== '-' ? formatNumber(Number(text), 0) : text
        },
      },
      // Lần nhập kho
      {
        title: "Lần nhập kho",
        dataIndex: "receiveTimes",
        key: "receiveTimes",
        width: 140,
        onCell: () => ({
          className: 'text-right',
        }),
        render(text, record) {
          return text !== '-' ? formatNumber(Number(text), 0) : text
        },
      },
      // Ghi chú
      {
        title: "Ghi chú",
        dataIndex: "description",
        key: "description",
        width: 300,
      },
      // Thời gian nhập kho
      {
        title: "Thời gian nhập kho",
        dataIndex: "receiveTime",
        key: "receiveTime",
        width: 150,
        onCell: () => ({
          className: 'text-center',
        }),
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY HH:mm:ss",
        },
      },
      // Người nhập kho
      {
        title: "Người nhập kho",
        dataIndex: "receiveBy",
        key: "receiveBy",
        width: 200,
      },
    ])

    const tableRef = useRef<ActionType>();

    const constDataName = "HistoryReceive";

    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      setIsResizablePresent,
      handleResize,
    } = useResizableColumns<HistoryReceiveModel>(columns, setColumns, constDataName);

    return !loading ? (
      <div className="w-full py-3 px-5">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
            LỊCH SỬ NHẬP KHO
          </h3>
          <Button
            size="middle"
            loading={searchLoading}
            className="bg-blue-500 !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
            onClick={async (data: any) => {
              setSearchLoading(true);
              await historyReceivePresenter.exportExcelHistoryRecieve(dataSearch)
              setSearchLoading(false);
            }}
            type="primary"
          >
            <AiOutlineDownload className="block text-base" />
            <span className="block">Export Excel</span>
          </Button>
        </div>

        {/* Form nhập tìm kiếm */}
        <div className="w-full bg-white p-3.5 flex flex-col rounded mb-2 border border-neutral-300">
          <Form<SearchModel>
            initialValues={{ statusReceive: '' }}
            form={form}
            labelCol={{ span: 8 }}
            colon={false}
            wrapperCol={{ span: 16 }}
            className="grid grid-cols-2 [&_.ant-form-item]:mb-2 [&_.ant-form-item-label]:font-bold"
            onFinish={async (values) => {
              const search = {
                ...values,
                fromDate: values['fromDate'] ? dayjs(values['fromDate']).format("YYYY-MM-DD") : undefined,
                toDate: values['toDate'] ? dayjs(values['toDate']).format("YYYY-MM-DD") : undefined,
                paging: { ...dataSearch.paging, pageIndex: 1 }
              }
              setDataSearch(search)
              setSearchLoading(true)
              await getListDataTable(search)
              setSearchLoading(false)
            }}
          >
            {/* Số phiếu nhập kho */}
            <Form.Item name={'receiveNumber'} label="Số phiếu nhập kho">
              <Input />
            </Form.Item>
            {/* Thành phẩm / bán thành phẩm */}
            <Form.Item name={'productCode'} label="TP/BTP">
              <AntdSelect
                options={dropdownProduct}
                fieldNames={{ label: 'value', value: 'key' }}
                popupMatchSelectWidth={false}
                filterOption={false}
                allowClear
                showSearch
                onSearch={(value) => searchProduct(value)}
              />
            </Form.Item>
            {/* Số LOT */}
            <Form.Item name={'lotNumber'} label="Số LOT">
              <Input />
            </Form.Item>
            {/* Tình trạng TP/BTP nhập kho */}
            <Form.Item name={'statusReceive'} label="Tình trạng TP/BTP nhập kho">
              <AntdSelect
                options={tpbtpStatus}
                fieldNames={{ label: 'value', value: 'key' }}
              ></AntdSelect>
            </Form.Item>
            {/* Lệnh sản xuất  */}
            <Form.Item name={'workOrderCode'} label="Lệnh sản xuất">
              <AntdSelect
                options={dropdownWO}
                fieldNames={{ label: 'value', value: 'key' }}
                allowClear
                showSearch
                filterOption={false}
                onSearch={(value) => searchWO(value)}
              />
            </Form.Item>
            {/* Công đoạn nhập kho */}
            <Form.Item name={'stepCode'} label="Công đoạn nhập kho">
              <AntdSelect
                options={listRouting}
                fieldNames={{ label: 'stepName', value: 'stepCode' }}
                filterOption={false}
                allowClear
                showSearch
                onSearch={(value) => searchRouting(value)}
              />
            </Form.Item>
            {/* ngày nhập kho */}
            <Form.Item name='commonDate' initialValue={'Today'} label="Ngày nhập kho">
              <AntdSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={(value) => {
                  getDayByCommonDate(value)
                }}
              />
            </Form.Item>
            {/* Từ ngày  */}
            <Form.Item name={'fromDate'} label="Từ ngày" className="col-start-1">
              <DatePicker
                disabled={commonNgayNK !== 'Custom'}
                className="w-full"
                format={'DD/MM/YYYY'}
                placeholder="DD/MM/YYYY"
              />
            </Form.Item>
            {/* Đến ngày  */}
            <Form.Item name={'toDate'} label="Đến ngày">
              <DatePicker
                disabled={commonNgayNK !== 'Custom'}
                className="w-full"
                format={'DD/MM/YYYY'}
                placeholder="DD/MM/YYYY"
              />
            </Form.Item>
            <div className="col-span-2">
              <Button
                type="primary"
                loading={searchLoading}
                htmlType="submit"
                icon={<FaSearch className="font-bold text-default" />}
                className="!bg-primary hover:!bg-primary/90 !flex justify-between items-center !px-3 !rounded-sm !py-1 mx-auto"
              >
                Tìm kiếm
              </Button>
            </div>
          </Form>
        </div>

        {/* Table product */}
        <div className="w-full bg-white py-3 px-5 rounded border border-neutral-300">
          <CustomProTable<HistoryReceiveModel>
            loading={searchLoading}
            className="[&_.ant-table-tbody_.ant-table-cell]:!p-1 [&_.ant-table-header_.ant-table-cell]:!text-center"
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            columns={columns}
            dataSource={dataTable}
            options={{ reload: false, density: false, setting: true, fullScreen: true }}
            actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
            columnsState={{
              value:
                Object.keys(columnsState).length > 0
                  ? columnsState
                  : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            rowKey={"stt"}
            pagination={{
              pageSize: dataSearch.paging.pageSize,
              total: historyReceiveStore.historyReceiveResponse.recordsTotal,
              current: dataSearch.paging.pageIndex,
              responsive: true,
              pageSizeOptions: [10, 25, 50, 100],
              showSizeChanger: true,
              position: ["topRight"],
              style: { margin: "10px 0" },
              showTotal: (total, range) =>
                `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
              onChange: async (page, pageSize) => {
                const search = {
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    pageIndex: page,
                    pageSize: pageSize,
                  },
                }
                setDataSearch(search);
                setSearchLoading(true)
                await getListDataTable(search)
                setSearchLoading(false)
              },
            }}
            toolBarRender={() => [
              // lưu mẫu báo cáo
              <SaveReportForm
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                setIsResizablePresent={setIsResizablePresent}
              />,
            ]}
          />
          <TemplateReportModal
            ref={templateReportModalRef}
            {...templateReportModalProps}
          />
        </div>
      </div>
    ) : (
      <LoadingScreen />
    );
  });
}
